import React from 'react';
import { rrulestr } from 'rrule';
import { EventWhen } from '@package/components';

/**Mostra le date sia di eventi che di esperienze nelle preview */
const PreviewItemDates = ({ item }) => {
  const is_experience = item['@type'] === 'Esperienza' || item.is_experience;
  let start = item.start;
  let end = item.end;
  let show_dates = item['@type'] === 'Event' && (start != null || end != null);

  if (is_experience) {
    if (start || end) {
      show_dates = true;
    } else if (item.recurrence) {
      const rruleSet = rrulestr(item.recurrence, {
        compatible: true, //If set to True, the parser will operate in RFC-compatible mode. Right now it means that unfold will be turned on, and if a DTSTART is found, it will be considered the first recurrence instance, as documented in the RFC.
        forceset: true,
      });
      start = rruleSet.dtstart;
      end = rruleSet.rrules()[0]?.options?.until;
      if (!end) {
        const allOccurrences = rruleSet.all(); // attenzione: questo può essere costoso!
        end = allOccurrences[allOccurrences.length - 1];
      }

      if (start || end) {
        show_dates = true;
      }
    }
  }
  return show_dates ? (
    <div className="item-info">
      {item.date_text ? (
        <p className="item-data">{item.date_text}</p>
      ) : (
        <EventWhen
          start={start}
          end={end}
          whole_day={item.whole_day}
          open_end={item.open_end}
          show_times={false}
        />
      )}
    </div>
  ) : (
    <></>
  );
};

export default PreviewItemDates;
